// KnowledgePage.tsx
import React, { FC, useEffect, useState } from "react";
import TrainingCrew from "../molecules/TrainingCrew";
import SectionHeader from "../molecules/SectionHeader";
import { useParams } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import MainLayout from "../../Layouts/MainLayout";
import { usePhase } from "../../../context/PhaseContext";
import { service } from "../../../services/AxiosServices";
import { toast } from "react-toastify";
import ConfirmDialog from "../atoms/ConfirmDialog";
import Spinner from "../atoms/Spinner";
import AccessControl from "../molecules/AccessControl";
import AccessDenied from "../atoms/AccessDenied";
import useAccessCheckLoading from "../../../utils/useAccessCheckLoading";
const KnowledgePage: FC = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const { getPhase, fetchPhase } = usePhase();
  const currentPhase = getPhase(Number(id));

  const crewSpace = location.pathname.startsWith("/training-crew");
  const crewAnalyze = location.pathname.includes("/crew-analyze");
  const crewPrepare = location.pathname.includes("/crew-prepare");

  const spaceAnalyze = location.pathname.includes("/space-analyze");
  const spacePrepare = location.pathname.includes("/space-prepare");
  const trainingSpace = location.pathname.includes("/training-space");

  const analysedRecords = crewAnalyze || spaceAnalyze;
  const preparedRecords = spacePrepare || crewPrepare;
  const phaseCategory =
    crewAnalyze || crewPrepare || crewSpace
      ? "crew"
      : spaceAnalyze || spacePrepare || trainingSpace
      ? "knowledge_hub"
      : "";

  const [showCompleteDialog, setShowCompleteDialog] = useState(false);
  const [showRevertDialog, setShowRevertDialog] = useState(false);
  const accessCheckLoading = useAccessCheckLoading()

  useEffect(() => {
    if (id) {
      fetchPhase(Number(id), phaseCategory);
    }
  }, [id]);

  const handleAdd = () => {
    let path = "";

    if (trainingSpace) {
      path = `/training/${id}`;
    } else if (crewSpace) {
      path = `/trained-crews/${id}`;
    } else if (crewAnalyze) {
      path = `/crew-analyzed-records/${id}`;
    } else if (crewPrepare) {
      path = `/crew-prepared-records/${id}`;
    } else if (spaceAnalyze) {
      path = `/space-analyzed-records/${id}`;
    } else if (spacePrepare) {
      path = `/space-prepared-records/${id}`;
    }

    navigate(path);
  };
  const phaseCheck = ()=>{
    let phase;
    if(analysedRecords){
       phase = 0
    }
    else if(preparedRecords){
      phase = 1
    }
    else if(crewSpace|| trainingSpace){
      phase = 3
    }
    return phase;
  }
  
  const handleComplete = async () => {
    setShowCompleteDialog(true);
  };
  

  const confirmComplete = async () => {
    let phase = phaseCheck()
    if(currentPhase === phase){
      try {
        const formData = {
          entity_id: id,
          entity_type: phaseCategory,
          phase: currentPhase,
  
          user_id: localStorage.getItem("user"),
        };
        await service<any>(`api/update-phase`, "post", formData);
        fetchPhase(Number(id), phaseCategory);
        toast.success("Training phase is completed", { autoClose: 2000 });
      } catch (err) {
        console.log(err);
      }
    }
    else {
      toast.warning('Please complete previous phase!',{autoClose:2000})
    }
   
  };

  const phaseDetails = () => {
    if (analysedRecords) {
      return 0;
    } else if (preparedRecords) {
      return 1;
    } else if (crewSpace || trainingSpace) {
      return 3;
    }
  };

  const handleRevert = async () => {
    setShowRevertDialog(true);
  };
  const confirmRevert = async () => {
    const toastMessage = analysedRecords
      ? "Analyze  phase"
      : preparedRecords
      ? "Prepare phase"
      : "Training   ";
    try {
      const formData = {
        entity_id: id,
        entity_type: phaseCategory,
        phase: phaseDetails(),
        revert: true,
        user_id: localStorage.getItem("user"),
      };
      await service<any>(`api/update-phase`, "post", formData);
      fetchPhase(Number(id), phaseCategory);
      toast.success(` ${toastMessage} reverted successfully`, {
        autoClose: 2000,
      });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <MainLayout>


      <AccessControl
        requiredPermissions={[
          {
            permission:  crewAnalyze ? 'crew_analyze_documents' :spaceAnalyze ? 'analyze_documents' :
                  crewPrepare? 'prepare_document' : spacePrepare?'prepare_documents':
                  crewSpace  ? 'training': trainingSpace ? 'knowledge_hub' : '',
                   types: ["read"]
          },
        ]}
        renderNoAccess={ accessCheckLoading ? <Spinner/> :<AccessDenied />}
      >
      
        <SectionHeader
          back={true}
          phase={currentPhase}
          complete={handleComplete}
          title={
            crewAnalyze || crewPrepare || spaceAnalyze || spacePrepare
              ? "Upload document"
              : "Knowledge hub training center"
          }
          onAdd={handleAdd}
          revert={handleRevert}
          trainingSpace={trainingSpace}
          crewSpace={crewSpace}
          crewAnalyze={crewAnalyze}
          crewPreparePhase={crewPrepare}
          spaceAnalyzePhase={spaceAnalyze}
          spacePreparePhase={spacePrepare}
          action={
            analysedRecords
              ? "Analyzed records"
              : preparedRecords
              ? "Prepared Records"
              : "Knowledge history"
          }
          train={true}

        />

        <ConfirmDialog
          show={showCompleteDialog}
          onHide={() => setShowCompleteDialog(false)}
          onConfirm={confirmComplete}
          title="Confirm complete"
          body="Are you sure you want to complete this phase?"
          confirmText="Complete"
        />

        {/* Confirm Revert Dialog */}
        <ConfirmDialog
          show={showRevertDialog}
          onHide={() => setShowRevertDialog(false)}
          onConfirm={confirmRevert}
          title="Confirm revert"
          body="Are you sure you want to complete this phase?"
          confirmText="Revert"
        />
        <TrainingCrew
          phase={currentPhase}
          crewAnalyze={crewAnalyze}
          crewPrepare={crewPrepare}
          crewSpace={crewSpace}
          spaceAnalyze={spaceAnalyze}
          spacePrepare={spacePrepare}
          trainingSpace={trainingSpace}
          Id={id || ""}
        />
        </AccessControl>
      </MainLayout>
    </>
  );
};

export default KnowledgePage;
